import { IEventDirectoryFirestoreDoc } from "./types";

export const compareEventDirectoryWithGivenArray = ({
  eventDirectories,
  directoryIds,
}: {
  eventDirectories: IEventDirectoryFirestoreDoc[];
  directoryIds: string[];
}): boolean => {
  const sortedEventDirectories = eventDirectories
    .map((directory) => directory?.id)
    .sort()
    .filter(Boolean);
  const sortedDirectoryIds = directoryIds.sort().filter(Boolean);
  return (
    sortedEventDirectories.length === sortedDirectoryIds.length &&
    sortedEventDirectories.every(
      (directoryId, index) => directoryId === sortedDirectoryIds[index],
    )
  );
};
